/**
 * Ready-made heroes: finished character art (drawn for the game, art batch 11)
 * that a player can wear instead of their own drawing. Looks only: the hero
 * keeps its class, skill and stats. Each one is sold for coins earned in play
 * (frontend cosmetics, `look:<id>`) or for real money (shared/shop.ts).
 *
 * The art lives at `hero:<id>` like the class heroes, so a fighter's
 * `look.preset` can name it and every client draws it.
 */

export interface HeroLook {
  id: string;
  name: string;
  note: string;
  /** What the artist draws (art brief). */
  art: string;
}

/** Coins for one ready-made hero. */
export const LOOK_COINS = 3000;
/** Baht for one ready-made hero. */
export const LOOK_THB = 29;

export const HERO_LOOKS: HeroLook[] = [
  { id: 'star_idol', name: 'Star Idol', note: 'Sings, dances and wins.', art: 'Pop-star kid with a star-shaped microphone, sparkly pink jacket, star hair clips, one hand waving to fans.' },
  { id: 'dino_hoodie', name: 'Dino Hoodie Kid', note: 'Rawr! Means "I win" in dinosaur.', art: 'Kid in a green dinosaur onesie hoodie with soft felt back spikes and a stuffed tail, little claw mittens.' },
  { id: 'kitty_witch', name: 'Kitty Witch', note: 'Brews spells with milk and glitter.', art: 'Little witch with a cat-ear witch hat, purple star cape, broom made from a giant paintbrush, black kitten on the shoulder.' },
  { id: 'robo_buddy', name: 'Robo Buddy', note: 'Built from a box. Powered by snacks.', art: 'Kid inside a cardboard-box robot suit: bottle-cap buttons, tin-foil arms, a torch-light antenna, marker-drawn dials.' },
  { id: 'paper_samurai', name: 'Paper Samurai', note: 'Folded armour, sharp moves.', art: 'Kid samurai in folded origami armour (red and white paper), wooden-ruler katana, headband with a paper crane.' },
  { id: 'bunny_princess', name: 'Bunny Princess', note: 'Royal, fluffy and very fast.', art: 'Princess in a pastel ball gown, tiara with bunny ears, carrot sceptre with a ribbon, fluffy pom-pom shoes.' },
  { id: 'space_ranger', name: 'Space Ranger', note: 'To the last page and beyond!', art: 'Kid astronaut with a round fishbowl helmet, white suit with crayon patches, jetpack made of two soda bottles.' },
  { id: 'boba_knight', name: 'Boba Knight', note: 'Armoured in tea. Lance of straw.', art: 'Knight whose helmet is a bubble-tea cup with tapioca pearls, giant striped straw as a lance, cup-lid shield.' },
];

export function heroLook(id: string): HeroLook | undefined {
  return HERO_LOOKS.find((l) => l.id === id);
}

/** The cosmetic a player owns for a ready-made hero. */
export const lookItem = (id: string): string => `look:${id}`;
